import { TimeSlot } from './../Models/timeslot.model';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimeslotService {


  url = environment.Url+'TimeSlots';

  header = new HttpHeaders({

    'Authorization': 'token' + localStorage.getItem('token')

  })

  constructor(private http: HttpClient) { }




  registerTimeSlot(body){
    return this.http.post<TimeSlot>(this.url,body).pipe(
     catchError(this.handleError)
   );
     }

   getTimeSlots(){
    return this.http.get<TimeSlot[]>(this.url).pipe(catchError(this.handleError)
    
    );
   }
   getTimeSlotById(id){
    return this.http.get<TimeSlot>(this.url+'/'+id)
  }

  updateTimeSlot(id,body){
   return this.http.put<TimeSlot>(this.url+'/'+id,body).pipe(catchError(this.handleError));
  }

  deleteTimeSlot(id){
return this.http.delete<TimeSlot>(this.url+'/'+id).pipe(catchError(this.handleError));
  }



  
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error)
        return throwError(
          error.error
        )


      }
     else if(error.status ==401){
       return throwError('invalid username or password')

     }
      else if (error.status == 0) {
        return throwError(
          'network failure please try again later '
        )
      }
      return throwError(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };


}



